export const UNLOCK_ACCOUNT_ADMIN_USER = "UNLOCK_ACCOUNT_ADMIN_USER"
export const UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS = "UNLOCK_ACCOUNT_ADMIN_USER_SUCCESS"
export const UNLOCK_ACCOUNT_ADMIN_USER_ERROR = "UNLOCK_ACCOUNT_ADMIN_USER_ERROR"

export const UNLOCK_TOKEN_ADMIN_USER = "UNLOCK_TOKEN_ADMIN_USER"
export const UNLOCK_TOKEN_ADMIN_USER_SUCCESS = "UNLOCK_TOKEN_ADMIN_USER_SUCCESS"
export const UNLOCK_TOKEN_ADMIN_USER_ERROR = "UNLOCK_TOKEN_ADMIN_USER_ERROR"